import styled from "styled-components";

export const CenteredContainer = styled.div`
  text-align: center;
`;
